import cloneDeep from 'lodash/cloneDeep'

export default {
  SET_SEARCH_RESULT(state, searchResult) {
    state.searchResult = searchResult
  },
  SET_LOADING(state, loading) {
    state.loading = loading
  },
  UPDATE_SORT_OPTIONS(state, { sortBy, descending }) {
    state.sortOptions.sortBy = sortBy
    state.sortOptions.descending = descending
  },
  UPDATE_REQUEST_STATUS_FILTER(state, requestStatus) {
    state.filter.requestStatus = requestStatus
  },
  SET_KEYWORD_FILTER(state, keyword) {
    state.filter.keyword = keyword
  },
  SET_PAGE(state, { pageSize, pageNo }) {
    state.page = { pageSize, pageNo }
  },
  UPDATE_SELECTED_ITEMS(state, selectedItems) {
    state.selectedItems = cloneDeep(selectedItems)
  },
}
